import { render, staticRenderFns } from "./ExamBankChoose.vue?vue&type=template&id=22934394&scoped=true&"
import script from "./ExamBankChoose.vue?vue&type=script&lang=js&"
export * from "./ExamBankChoose.vue?vue&type=script&lang=js&"
import style0 from "./ExamBankChoose.vue?vue&type=style&index=0&id=22934394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22934394",
  null
  
)

export default component.exports